/* eslint-disable @typescript-eslint/naming-convention */
import { css } from 'styled-components';
import product from '@bookingForm/themes/product';
import { SelectedOptionWrapper } from '@bookingForm/styles/form';
const accent = '#24195F';
const accentLight = '#01ACEA';
const accentAlt = '#00B3B5';
const invertedAccent = '#ffffff';
const numberInputColour = accent;
const border = '#f0f0f0';
const text = '#444';
const error = '#e11b20';
const success = '#0DB14B';
// eslint-disable-next-line max-len
const dottiesFont = 'Dotties, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif';
const upsellTheme = {
    ...product,
    themeName: 'upsell',
    formWrapper: css `
    ${SelectedOptionWrapper} {
      max-width: initial !important;
    }
    
    padding-left: 0;
    padding-right: 0;
  `,
    submitButton: css `
    width: 100%;
  `,
    submitWrapper: css `
    background-color: transparent;
    padding: 0;
    width: 100%;
    margin: -1rem auto 0;
  `,
    sessionSlide: css `
    margin-right: 0.6rem;
  `,
    sessionsWrapper: css `
    position: relative;
    margin-right: 0;
    background-color: ${invertedAccent};
    overflow: visible;
    
    .swiper {
      overflow: visible;
    }
  `,
    sessionsWrapperAfter: css `
    content: none;
  `,
    overviewWrapper: css `
    color: var(--text);
    background-color: transparent;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 100%;
    display: block;
    padding: 0;
  `,
};
export default upsellTheme;
